export default __webpack_public_path__ + "static/media/customer-emerald.90920f9d.jpg";